/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersSendEmailResponseSchema } from '../../models/members-send-email-response-schema';
import { MembersSendEmailSchema } from '../../models/members-send-email-schema';

export interface SendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost$Params {
  org: string;
      body: Array<MembersSendEmailSchema>
}

export function sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost(http: HttpClient, rootUrl: string, params: SendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersSendEmailResponseSchema>> {
  const rb = new RequestBuilder(rootUrl, sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost.PATH, 'post');
  if (params) {
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersSendEmailResponseSchema>;
    })
  );
}

sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost.PATH = '/api/v2/secretariat/members/members/emails';
